import React from 'react'
import { CustomHeaderProps } from 'ag-grid-react'
import styled from 'styled-components'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { CustomReportVariable } from '../../../../../redux/context/customReports/typesVariable'
import { TypedColDef } from './types'
import { parseDate } from '../../../../../config/dayjsConfig'
import { getCategoryTitleSegments, getCategoryPlainTitle } from '../print/CategoryTitleVisitor'
import SegmentList, { SegmentStyleMap } from '../print/SegmentList'
import './style.css'

const TABLE_SEGMENT_STYLES: SegmentStyleMap = {
  dataType: { fontSize: '0.9em', opacity: 0.7 },
  function: { opacity: 0.7 }
}

const HeaderCell = styled.div`
  overflow: hidden;
`

export type MyCustomHeaderProps = CustomHeaderProps<CustomReportVariable>

export const CreateInnerHeaderComponent = ({ column, context }: MyCustomHeaderProps) => {
  const colDef = column.getColDef() as TypedColDef
  const { category } = colDef.context || {}
  const { t } = useTranslation()

  if (!category) return null

  const segments = getCategoryTitleSegments(category, context.categories)
  const scenario = category.budgetingScenario

  const tooltipTitle = scenario ? (
    <>
      <div>{scenario.name || t('global:default')}</div>
      {scenario.forecastCursor && (
        <div>{t('global:actuals_until', { date: parseDate(scenario.forecastCursor)?.format('MM/YYYY') })}</div>
      )}
    </>
  ) : (
    getCategoryPlainTitle(category, context.categories)
  )

  return (
    <Tooltip title={tooltipTitle} styles={{ body: { lineHeight: '1rem', whiteSpace: 'pre-line' } }}>
      <HeaderCell style={scenario ? { color: '#0225a1' } : undefined}>
        <SegmentList segments={segments} styleMap={TABLE_SEGMENT_STYLES} />
      </HeaderCell>
    </Tooltip>
  )
}
